
import { Vue, Component, Prop } from 'vue-property-decorator';
import { types } from '../../api_types';
import T from '../../lang';
import * as ui from '../../ui';
import notifications_Clarifications from '../notification/Clarifications.vue';
import notifications_List from '../notification/List.vue';
import omegaup_Markdown from '../Markdown.vue';
import common_GraderStatus from '../common/GraderStatus.vue';
import common_GraderBadge from '../common/GraderBadge.vue';
import user_objectives_questions from '../user/ObjectivesQuestions.vue';
import user_next_registered_contest from '../user/NextRegisteredContest.vue';
import navbar_items from './NavbarItems.vue';
import { AvailableTabs } from '../login/Signin.vue';

import { library } from '@fortawesome/fontawesome-svg-core';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import { faSignOutAlt, faUser, faCog } from '@fortawesome/free-solid-svg-icons';
import LogoutConfirmation from './LogoutConfirmation.vue';
import NavbarItem from './NavbarItem.vue';
library.add(faSignOutAlt, faUser, faCog);

export const EventBus = new Vue();

@Component({
  components: {
    FontAwesomeIcon,
    'omegaup-notification-list': notifications_List,
    'omegaup-notifications-clarifications': notifications_Clarifications,
    'omegaup-common-grader-status': common_GraderStatus,
    'omegaup-common-grader-badge': common_GraderBadge,
    'omegaup-user-objectives-questions': user_objectives_questions,
    'omegaup-user-next-registered-contest': user_next_registered_contest,
    'omegaup-navbar-items': navbar_items,
    'omegaup-navbar-item': NavbarItem,
    'omegaup-markdown': omegaup_Markdown,
    'omegaup-logout-confirmation': LogoutConfirmation,
  },
})
export default class Navbar extends Vue {
  @Prop() omegaUpLockDown!: boolean;
  @Prop() inContest!: boolean;
  @Prop() isLoggedIn!: boolean;
  @Prop() isReviewer!: boolean;
  @Prop() gravatarURL51!: string;
  @Prop() gravatarURL128!: string;
  @Prop() associatedIdentities!: types.AssociatedIdentity[];
  @Prop() currentEmail!: string;
  @Prop() currentName!: string;
  @Prop() currentUsername!: string;
  @Prop() isAdmin!: boolean;
  @Prop() isSupportTeamMember!: boolean;
  @Prop() isMainUserIdentity!: boolean;
  @Prop() lockDownImage!: string;
  @Prop() navbarSection!: string;
  @Prop() notifications!: types.Notification[];
  @Prop() graderInfo!: types.GraderStatus | null;
  @Prop() graderQueueLength!: number;
  @Prop() errorMessage!: string | null;
  @Prop({ default: 0 }) profileProgress!: number;
  @Prop() clarifications!: types.Clarification[];
  @Prop() fromLogin!: boolean;
  @Prop() userTypes!: string[];
  @Prop() nextRegisteredContest!: types.ContestListItem | null;
  @Prop() isUnder13User!: boolean;
  @Prop() mentorCanChooseCoder!: boolean;
  @Prop() userVerificationDeadline!: Date | null;

  T = T;
  ui = ui;
  AvailableTabs = AvailableTabs;
  logoutModalVisible = false;
  scrollY: number = 0;
  teachingUserTypes = ['teacher', 'coach', 'independent-teacher'];
  hasTeachingObjective = this.teachingUserTypes.some((teachingType) =>
    this.userTypes.includes(teachingType),
  );

  get formattedLoginURL(): string {
    let path = window.location.pathname;
    if (path === '/login' || path === '/login/') {
      path = '/';
    }
    return `/login/?redirect=${encodeURIComponent(path)}#login`;
  }

  get formattedSignupURL(): string {
    let path = window.location.pathname;
    if (path === '/login' || path === '/login/') {
      path = '/';
    }
    return `/login/?redirect=${encodeURIComponent(path)}#signup`;
  }

  get identitiesNotLoggedIn(): types.AssociatedIdentity[] {
    return this.associatedIdentities.filter(
      (identity) => identity.username !== this.currentUsername,
    );
  }

  readNotifications(notifications: types.Notification[], url?: string): void {
    this.$emit('read-notifications', notifications, url);
  }

  get daysUntilVerificationDeadline(): number | null {
    if (!this.userVerificationDeadline) {
      return null;
    }
    const today = new Date();
    const deadline = new Date(this.userVerificationDeadline);
    const timeDifference = deadline.getTime() - today.getTime();
    const daysDifference = Math.ceil(timeDifference / (1000 * 3600 * 24));
    return daysDifference;
  }

  get bannerColor() {
    if (
      this.daysUntilVerificationDeadline !== null &&
      this.daysUntilVerificationDeadline <= 1
    ) {
      return 'bg-danger';
    }
    return 'bg-warning';
  }

  emitActiveTab(tab: AvailableTabs): void {
    EventBus.$emit('update:activeTab', tab);
    if (
      window.location.pathname === '/login' ||
      window.location.pathname === '/login/'
    ) {
      window.location.hash = `#${tab}`;
    } else {
      window.location.href =
        tab === AvailableTabs.Login
          ? this.formattedLoginURL
          : this.formattedSignupURL;
    }
  }

  get logoTooltip(): string {
    if (this.scrollY > 0) {
      return this.T.navbarScrollToTop;
    }
    return this.T.navbarGoToHomepage;
  }

  updateScroll(): void {
    this.scrollY = window.scrollY;
  }

  handleLogoClick(): void {
    const isAtTop = window.scrollY <= 0;
    const isHome = window.location.pathname === '/';

    if (!isAtTop) {
      window.scrollTo({ top: 0, behavior: 'smooth' });
      return;
    }

    if (!isHome) {
      window.location.href = '/';
    }
  }

  mounted() {
    document.addEventListener('click', this.handleDocumentClick);
    window.addEventListener('scroll', this.updateScroll);

    this.updateScroll();
  }

  beforeDestroy() {
    document.removeEventListener('click', this.handleDocumentClick);
    window.removeEventListener('scroll', this.updateScroll);
  }

  private handleDocumentClick(event: MouseEvent) {
    const target = event.target as HTMLElement;
    const navbar = this.$el as HTMLElement;

    if (!navbar.contains(target)) {
      const navbarCollapse = navbar.querySelector('.navbar-collapse.show');

      if (!navbarCollapse) return;

      ($(navbarCollapse) as any).collapse('hide');
    }
  }
}
